import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconChevronRightOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M11.96 6.96a1 1 0 0 1 1.414 0l8.333 8.333a1 1 0 0 1 0 1.414l-8.333 8.333a1 1 0 0 1-1.414-1.414L19.586 16 11.96 8.374a1 1 0 0 1 0-1.414" /></svg>;
export default SvgIconChevronRightOutlined;